import * as React from "react";
import { observer } from "mobx-react";
import MProductsStore from "./store";
import { TProductElement, TProductBaseProps } from "../../../services/product";
import { ProductSkeletonContainer, ProductWrap } from "./styles.index";
import { fetchCardBoxByGrid } from "./styles.card";
import ScrollLoad from "../../components/ScrollLoad";
import { isNotBlankArray } from "utils/array";
import { ModuleLayoutStyle } from "../../../services/playground";

import ViewMoreCard from "../../components/ViewMoreCard";
import NormalProductCard from "./ProductCard";
import NormalProductCardTag from "./TagGroup";
import SlideProductGroup from "./SlideTemplate";
import SmallLoading from "../../components/SmallLoading";
import { isInWindowView, returnProductIndex } from "utils/browser";

export type NormalProductGroupProps = TProductBaseProps & {
	isRollable?: boolean;
	viewMore?: string;
};

interface NormalProductGroupState {
	activeTab: string;
	isChangeTab: boolean;
	activeTabIndex: number;
	showedProducts: TProductElement[];
	productMinHeight?: number;
}
@observer
class NormalProductGroup extends React.Component<NormalProductGroupProps, NormalProductGroupState> {
	MNormalProductStore: MProductsStore;
	scrollEndTimer: NodeJS.Timeout;
	scrollTop: number = 0;
	// preProductIndex: number = 0;

	state: NormalProductGroupState = {
		activeTab: this.props.activeTab || this.props.productModules?.[0]?.poolId || "",
		isChangeTab: false,
		showedProducts: [],
		activeTabIndex: this.props.activeTabIndex || 0,
		productMinHeight: 0,
	};
	private newCardRef: React.RefObject<HTMLDivElement> = React.createRef();
	private slideSetionGroupRef: React.RefObject<HTMLDivElement> = React.createRef();
	private slideGroupRef: any;
	private productCardIdsMap: Map<string, [string]> = new Map();

	constructor(props: NormalProductGroupProps) {
		super(props);
		this.MNormalProductStore = new MProductsStore(props.productModules);
		const activeTab = props.activeTab || props.productModules[0]?.poolId;

		this.state = {
			activeTab,
			isChangeTab: false,
			activeTabIndex: Math.max(
				0,
				props?.tagGroup?.findIndex((tag) => tag?.id === props?.activeTab) || 0,
			),
			showedProducts: this.MNormalProductStore.productsListMap[activeTab] || [],
		};
	}
	componentDidMount() {
		const { loadProductsList, productsListMap } = this.MNormalProductStore;
		const currentPool = productsListMap[this.state.activeTab];
		if (!isNotBlankArray(currentPool) && this.props.isRollable) {
			loadProductsList(this.state.activeTab, this.props.onLoadPool);
		}
		/** 页面初始化有产品展示需要记录曝光 */
		this.trackOnShow();
		this.onJudeSildeInWindow();
		window.addEventListener("scroll", this.onScroll);
	}
	componentWillUnmount() {
		window.removeEventListener("scroll", this.onScroll);
	}
	onScroll = () => {
		clearTimeout(this.scrollEndTimer);
		this.scrollEndTimer = setTimeout(this.isScrollEnd, 600);
		this.scrollTop = window.scrollY || window.pageYOffset;
	};
	isScrollEnd = () => {
		const endTop = window.scrollY || window.pageYOffset;

		const currentElement = this.newCardRef?.current as HTMLElement;
		if (endTop === this.scrollTop && isInWindowView(currentElement)) {
			this.trackOnShow();
		}
		if (this.slideGroupRef && this.slideGroupRef.onHandleTouchEndExport) {
			this.slideGroupRef?.onHandleTouchEndExport();
		}
		if (this.slideGroupRef && this.slideGroupRef.onHandleTouchEndExport) {
			this.slideGroupRef?.onHandleTouchEndExport();
		}
	};
	trackOnShow = async (showItems?: string[]) => {
		const { SetCtrTrackOnShow, SetGtmTrackOnShow, isRollable } = this.props;
		const { showedProducts, activeTab } = this.state;
		const { handleExposureProductList, exposureProductListMap, productsListMap } =
			this.MNormalProductStore;
		const productList = productsListMap[activeTab];
		const exposureProducts = exposureProductListMap[activeTab] || null;
		if (showedProducts.length > 0) {
			const posArr: number[] = [];
			const pidsArr: string[] = [];
			let exportArr: string[] = [];
			showedProducts.forEach((item) => {
				const showHtml = document.getElementById(`${activeTab}${item.gpid}`);
				const showItemId = showItems?.find((gpid) => gpid === item.gpid);
				const showItemIdHtml = document.getElementById(`${activeTab}${showItemId}`);
				let exposureItem = null;
				const productIndex = returnProductIndex(item.gpid, productList);
				if (exposureProducts) {
					exposureItem = exposureProducts.find((it) => it === item.gpid);
					exportArr = exposureProducts;
				}
				if (
					showHtml &&
					isInWindowView(showHtml) &&
					!exposureItem &&
					productIndex &&
					!isRollable
				) {
					posArr.push(productIndex);
					pidsArr.push(item.gpid);
					exportArr.push(item.gpid);
				}
				/** 页面Rollable的 */
				if (
					showItemIdHtml &&
					isInWindowView(showItemIdHtml) &&
					productIndex &&
					!exposureItem &&
					isRollable
				) {
					posArr.push(productIndex);
					pidsArr.push(item.gpid);
					exportArr.push(item.gpid);
				}
			});
			if (posArr.length > 0) {
				SetCtrTrackOnShow && SetCtrTrackOnShow(posArr.join(","), pidsArr);
				SetGtmTrackOnShow && SetGtmTrackOnShow(showedProducts, posArr);
				handleExposureProductList(activeTab, exportArr);
			}
			// this.preProductIndex = this.preProductIndex + showedProducts.length;
		}
	};
	onLoadMoreProducts = async () => {
		const poolId: string = this.state.activeTab;
		const { loadProductsList, isLoadEnd, productsListMap } = this.MNormalProductStore;
		const newProducts = (await loadProductsList(poolId, this.props.onLoadPool)) || [];
		const products = productsListMap[poolId];
		this.setState({
			showedProducts: [...this.state.showedProducts, ...newProducts],
		});
		return { loadCount: products?.length, isError: false, isDisable: isLoadEnd[poolId] };
	};

	// 页面滚动方法公用提取
	clickTabScrollTo = (fixed: boolean) => {
		if (fixed) {
			setTimeout(() => {
				const { stickToTop } = this.props;
				const offsetTop = this.newCardRef?.current?.offsetTop;
				// 移动端兼容问题
				window.scrollTo({
					top: Math.max(0, offsetTop - stickToTop),
					behavior: "smooth",
				});
				// 给商品模块最小高度需要去除
				setTimeout(() => {
					this.setState({ productMinHeight: 0 });
				}, 200);
			}, 100);
		} else {
			// 没有固定时也暂时给一个最小高度，再去除
			setTimeout(() => {
				this.setState({ productMinHeight: 0 });
			}, 100);
		}
	};

	onChangeTab = async (poolId: string, index: number, fixed?: boolean) => {
		const clientHeight = this.newCardRef?.current?.clientHeight;
		if (this.props.onClickTab) {
			this.props.onClickTab(index);
			this.clickTabScrollTo(fixed);
		}
		this.setState({
			activeTab: poolId,
			activeTabIndex: index,
			productMinHeight: clientHeight,
		});
		if (isNotBlankArray(this.MNormalProductStore.productsListMap[poolId])) {
			const showeProducts = this.MNormalProductStore.productsListMap[poolId];
			this.setState({
				showedProducts: showeProducts,
			});
			// return;
		} else {
			// this.preProductIndex = 0;
			this.setState(
				{
					isChangeTab: true,
					showedProducts: [],
				},
				async () => {
					const { loadProductsList } = this.MNormalProductStore;
					const newProducts =
						(await loadProductsList(poolId, this.props.onLoadPool)) || [];
					this.setState({
						showedProducts: [...this.state.showedProducts, ...newProducts],
						isChangeTab: false,
					}, () => {
						this.clickTabScrollTo(fixed);
					});
					this.trackOnShow();
					this.onJudeSildeInWindow();
				},
			);
		}
	};
	onClickProduct = (pos: string, pid: string) => {
		this.props.SetCtrTrackOnAction && this.props.SetCtrTrackOnAction(pos, pid);
	};
	handleSlideProduct = (mapKey: string, idList: string[]) => {
		const showItems: string[] = [];
		if (idList.length > 0) {
			idList.forEach((id) => {
				const showId =
					this.productCardIdsMap.get(mapKey)?.find((gpid) => `${mapKey}${gpid}` === id) ||
					null;
				showId && showItems.push(showId);
			});
		}
		this.trackOnShow(showItems);
	};
	onRenderProductIdsCard = (activeTabKey: string, gpid: string) => {
		if (activeTabKey && gpid) {
			let productCardIdsList: any = [];
			if (this.productCardIdsMap.get(activeTabKey)) {
				productCardIdsList = this.productCardIdsMap.get(activeTabKey);
			}
			const ind = productCardIdsList.findIndex(
				(item: { gpid: string }) => item.gpid === gpid,
			);
			if (ind === -1) {
				productCardIdsList.push(gpid);
			} else {
				productCardIdsList[ind] = gpid;
			}
			this.productCardIdsMap.set(activeTabKey, productCardIdsList);
		}
	};
	onJudeSildeInWindow = () => {
		const slideElement = this.slideSetionGroupRef?.current as HTMLElement;
		if (
			slideElement &&
			isInWindowView(slideElement) &&
			this.slideGroupRef &&
			this.slideGroupRef.onHandleTouchEndExport
		) {
			this.slideGroupRef.onHandleTouchEndExport();
		}
	};

	renderMProductsList = () => {
		const {
			isRollable,
			layout,
			placeholderBg,
			isInApp,
			viewMore = "View More",
			notUseQnparams = false,
			scoreOptions = {},
			productDisplayInfo,
		} = this.props;
		const products = this.MNormalProductStore.productsListMap[this.state.activeTab] || [];
		const viewMoreLink = this.MNormalProductStore.viewMoreLink[this.state.activeTab];

		if (!isNotBlankArray(products)) {
			return null;
		}

		return [
			products.map((pool: TProductElement, index: number) => {
				isRollable && this.onRenderProductIdsCard(this.state.activeTab, pool.gpid);
				return (
					<NormalProductCard
						columnNum={layout.columnNum || 2}
						key={index}
						onClick={() => this.onClickProduct((index + 1).toString(), pool.gpid)}
						productElement={pool}
						index={index}
						isRollable={!!isRollable}
						displayInfo={productDisplayInfo}
						isWithViewMore={!!viewMoreLink}
						stylesForCard={this.props.stylesForCard}
						placeholderBg={placeholderBg}
						notUseQnparams={notUseQnparams}
						isInApp={!!isInApp}
						collectOptions={scoreOptions}
						layoutStyle={this.props.layoutStyle || ModuleLayoutStyle.Orange}
						poolId={this.state.activeTab}
					/>
				);
			}),
			<>
				{!!viewMoreLink && (
					<ViewMoreCard
						StyledComponent={fetchCardBoxByGrid(+(layout.columnNum || 2))}
						isRollable={isRollable}
						key={`${viewMoreLink}_VIEWMORE`}
						link={viewMoreLink}
						text={viewMore}
						isInApp={!!isInApp}
					/>
				)}
			</>,
		];
	};

	render() {
		const { positionId, stickToTop = 0, canScrollFixed, isRollable, layout } = this.props;
		const poolId = this.state.activeTab;
		const products = this.MNormalProductStore.productsListMap[this.state.activeTab];
		let loading = poolId ? this.MNormalProductStore.isLoadingProducts[poolId] : false;

		const { gap = 0.5, columnNum = 2, parentGap = 0.5 } = layout;
		loading = loading || this.state.isChangeTab;
		const hasTag = isNotBlankArray(this.props.tagGroup);
		const { productMinHeight } = this.state;
		return (
			<ProductWrap id={positionId} ref={this.newCardRef} style={{ minHeight: productMinHeight }}>
				{hasTag && (
					<NormalProductCardTag
						activeTab={this.props.activeTab || ""}
						activeTabIndex={this.state.activeTabIndex}
						canScrollFixed={!!canScrollFixed}
						stickToTop={stickToTop}
						clientElement={this.newCardRef}
						tagGroup={this.props.tagGroup || []}
						onClick={this.onChangeTab}
					/>
				)}
				{/* 有标签增加标签与模块间的间距 */}
				{hasTag && <div style={{ height: "0.75rem" }}></div>}
				{isRollable ? (
					<section id={poolId} key={poolId} ref={this.slideSetionGroupRef}>
						<SlideProductGroup
							gridGap={gap}
							parentGap={parentGap}
							isLoading={loading && !isNotBlankArray(products)}
							isValid={isNotBlankArray(products)}
							onLoadMoreContent={() => {
								this.MNormalProductStore.loadProductsList(
									poolId,
									this.props.onLoadPool,
								);
							}}
							poolId={poolId}
							handleSlideProduct={(mapKey: string, ids: string[]) => {
								this.handleSlideProduct(mapKey, ids);
							}}
							ref={(ref) => (this.slideGroupRef = ref)}
						>
							{this.renderMProductsList()}
						</SlideProductGroup>
					</section>
				) : (
					<ScrollLoad
						StyleComponent={ProductSkeletonContainer}
						grid={{ gridCol: columnNum, gridGap: gap, parentGap }}
						isDisable={this.MNormalProductStore.isLoadEnd[poolId]}
						loadFunction={this.onLoadMoreProducts}
						loadDataWhenDidMount={false}
					>
						{this.renderMProductsList()}
						{loading && <SmallLoading />}
					</ScrollLoad>
				)}
			</ProductWrap>
		);
	}
}

export default NormalProductGroup;
